var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 5.83329C10.7292 5.83329 11.6667 4.89579 11.6667 3.74996C11.6667 2.60413 10.7292 1.66663 9.58333 1.66663C8.4375 1.66663 7.5 2.60413 7.5 3.74996C7.5 4.89579 8.4375 5.83329 9.58333 5.83329Z",
    fill: "#23252F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 7.91663C8.4375 7.91663 7.5 8.85413 7.5 9.99996C7.5 11.1458 8.4375 12.0833 9.58333 12.0833C10.7292 12.0833 11.6667 11.1458 11.6667 9.99996C11.6667 8.85413 10.7292 7.91663 9.58333 7.91663Z",
    fill: "#23252F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58333 14.1666C8.4375 14.1666 7.5 15.1041 7.5 16.25C7.5 17.3958 8.4375 18.3333 9.58333 18.3333C10.7292 18.3333 11.6667 17.3958 11.6667 16.25C11.6667 15.1041 10.7292 14.1666 9.58333 14.1666Z",
    fill: "#23252F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDots);
export default __webpack_public_path__ + "static/media/table-dots.dc6479f9764b775874edc93ae9b53944.svg";
export { ForwardRef as ReactComponent };